import React from 'react'
import {ButtonBase, ButtonShape, ComponentSize} from '@influxdata/clockface'
import {
  AnalyticsClient,
  GoogleAnalyticsClient,
} from '../../client/GoogleAnalyticsClient'

interface Props {
  buttonText: string
  children: JSX.Element
  handleClick?: () => void
  analyticsClient?: AnalyticsClient
  className?: string
}

const getAnalyticsClient = () => {
  return new GoogleAnalyticsClient(window.dataLayer)
}

const SocialButton = ({
  buttonText,
  children,
  className,
  handleClick,
  analyticsClient,
}: Props): JSX.Element => {
  const client = analyticsClient || getAnalyticsClient()

  const onClick = () => {
    client.send_event('influx_cloud_signup_started', {
      identity_provider: buttonText,
    })
    handleClick()
  }

  return (
    <ButtonBase
      onClick={onClick}
      size={ComponentSize.Large}
      shape={ButtonShape.StretchToFit}
      className={className}
    >
      {children}
      <span className="social-button--text">{buttonText}</span>
    </ButtonBase>
  )
}

export default SocialButton
